import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../button/button.component';
import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';

interface ProgramChoice {
  heading?: string | null;
  routingUrl?: string | null;
}

@Component({
  selector: 'lib-select-program-modal',
  imports: [CommonModule, ModalLayoutComponent, ButtonComponent],
  templateUrl: './select-program-modal.component.html',
  styleUrl: './select-program-modal.component.scss',
})
export class SelectProgramModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SelectProgramModalComponent>);
  programs = signal<ProgramChoice[]>(this.data?.programs || []);

  select(routingUrl?: string | null) {
    this.dialogRef.close(routingUrl ?? null);
  }
}
